<script lang="ts">
	import Tab, { Label } from '@smui/tab/styled';
	import TabBar from '@smui/tab-bar/styled';
	import Select from 'svelte-select';
	import { getClient, query } from 'svelte-apollo';
	import { onMount } from 'svelte';
	import { getSegmentsQuery, getTargetsQuery } from '../../../graphql/queries/segments';
	import type { Segment, TrackingType } from 'Segments';

	const client = getClient();

	let keyedTabs = [
		{
			k: 1,
			icon: 'code',
			label: 'Trackingpoint',
			selectOptions: []
		},
		{
			k: 2,
			icon: 'code',
			label: 'DMP Segment',
			selectOptions: []
		}
	];

	let trackingsOptions = [];
	let segmentsOptions = [];

	const getTargetsOp = query(client, { query: getTargetsQuery });

	const getOptionsForTrackingPoint = async () => {
		const { data } = await getTargetsOp.refetch();

		data.trackings.map((target: TrackingType) => {
			keyedTabs[0].selectOptions.push({ label: target.tpName + " (ID " + target.tpId + ")", value: target.tpId });
			trackingsOptions.push({ label: target.tpName, value: target.tpId });
		});
		keyedTabsActive = keyedTabs[0];
	};

	const getSegmentsOp = query(client, { query: getSegmentsQuery });

	const getOptionsForDmpSegment = async () => {
		const { data } = await getSegmentsOp.refetch();

		data.segments.map((segment: Segment) => {
			if (segment.sendToAdForm) {
				keyedTabs[1].selectOptions.push({ label: segment.name, value: segment.id });
				segmentsOptions.push({ label: segment.name, value: segment.id });
			}
		});
	};

	onMount(() => {
		getOptionsForTrackingPoint();
		getOptionsForDmpSegment();
	});

	let keyedTabsActive = keyedTabs[0];
	export let trackingPoint: { value: string; label: string };
	export let dmpSegment: { value: string; label: string };
</script>

<section>
	<div>
		<TabBar tabs={keyedTabs} let:tab bind:active={keyedTabsActive}>
			<Tab
				{tab}
				indicatorSpanOnlyContent={true}
				tabIndicator$transition="fade"
				type="button"
				on:click={() => {
					trackingPoint = { value: '', label: '' };
					dmpSegment = { value: '', label: '' };
				}}
			>
				<Label>{tab.label}</Label>
			</Tab>
		</TabBar>
		<div class="lookalike-select-wrap">
			<div class="select-wrap">
				{#if keyedTabsActive.label === 'Trackingpoint'}
					<Select
						selectedValue={trackingPoint}
						items={keyedTabsActive.selectOptions}
						on:select={(e) => {
							trackingPoint = e.detail;
						}}
						on:clear={() => {
							trackingPoint = { value: '', label: '' };
						}}
					/>
				{:else}
					<Select
						selectedValue={dmpSegment}
						items={keyedTabsActive.selectOptions}
						on:select={(e) => {
							dmpSegment = e.detail;
						}}
						on:clear={() => {
							dmpSegment = { value: '', label: '' };
						}}
					/>
				{/if}
			</div>
		</div>
	</div>
</section>

<style>
	.lookalike-select-wrap {
		/*  background-color: white;*/
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex: 1;
		padding: 20px;
		padding-top: 30px;
	}
	.select-wrap {
		display: flex;
		flex: 1;
		flex-direction: column;
	}
</style>
